import { useProductByHandle } from '@backpackjs/storefront';

export function useProductsByHandles({ handles = [], fetchOnMount }) {
  if (!handles?.length) {
    return;
  }

  const hooks = handles.map((handle) => useProductByHandle({ handle, fetchOnMount }));

  return {
    products: hooks.map((hook) => hook.product),
    hooks,
  };
}
